export default "__VITE_ASSET__BbBf31Ed__"